import type { ChannelTranslationEntity } from './ChannelTranslationEntity'
import type { ChannelType } from '../enums/ChannelTypeEnum'
import type { ChannelStatus } from '../enums/ChannelStatusEnum'
import type { AppServiceType, FileUpload } from '@/backend/market'
import type { ChannelItemType } from '../enums/ChannelItemTypeEnum'
import type { ChannelActiveRegionEntity } from './ChannelActiveRegionEntity'

export class CreateUpdateChannelEntity {
  translations?: Array<ChannelTranslationEntity>
  imageUrl?: string
  imageData?: FileUpload
  coverImageData?: FileUpload
  coverImageUrl?: string
  type?: ChannelType
  status?: ChannelStatus
  itemType?: ChannelItemType
  appServiceType?: AppServiceType
  isVirtual?: boolean
  zohoBooksChannelName?: string
  zohoBooksChannelOrderType?: string
  regions?: ChannelActiveRegionEntity[]
  isBranchTagFilterMultiple?: boolean
  activeRegions?: ChannelActiveRegionEntity[]
  color?: string
}
